import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest,HttpResponse,HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/observable/throw'
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import * as CryptoJS from "crypto-js"
@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
    constructor(private router:Router) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.log("intercepted request ... ");
    let token=localStorage['auth-token']?localStorage.getItem('auth-token'):'null'
    let user=localStorage['user']?localStorage.getItem('user'):'{}'
    let sid=localStorage['sid']?localStorage.getItem('sid'):''
     var updatedRequest;
    if(req.urlWithParams=='http://ipinfo.io/?token=b9cb570fb57a5d'){
          updatedRequest=req;
    }else{
       //console.log(req.method)
       let crs='';
       if(req.method=='POST')
       {
         crs=CryptoJS.HmacSHA1(JSON.stringify(req.body), '1_2*_3$_4#')
       }
        updatedRequest = req.clone({
            headers: req.headers.set("Auth-Token", token).set('Access-Control-Allow-Credentials','true').set('user',user).set('sid',sid).set('crs',crs),withCredentials:true
        });
    }
   

    return next.handle(updatedRequest).do((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // process successful responses here
        }
      }, (error: any) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            localStorage.removeItem('user');
            localStorage.removeItem('auth-token');
            localStorage.removeItem('AuthToken');
            localStorage.removeItem('sid');
           // this.router.navigate(['/login'])
           window.location.href='https://pblabour.gov.in/eLabour/Account/Login';
          }
        }
      })
    .catch((error, caught) => {
   // console.log("Error Occurred");
  //  console.log(error);
    return Observable.throw(error);
    }) as any;
    }
}
